import React from 'react';
import DataTable from '../../Table';

const TabelaPatrimoniosSecretaria = ({ secretaria, cliente, patrimonios, onGoToVincular }) => {
  const headers = [
    { label: "Ramal", key: "ramal", sortable: true, width: 'w-1/10' },
    { label: 'Nome', key: 'nome', sortable: true, width: 'w-2/12', truncate: true },
    { label: 'Produto', key: 'produto', sortable: false, width: 'w-1/6' },
    { label: 'MAC', key: 'nMac', sortable: false, width: 'w-1/10' },
    { label: 'Setor', key: 'setor', sortable: false, width: 'w-1/10' },
    { label: 'Anexo', key: 'nome_anexo', sortable: false, width: 'w-1/6' },
    { label: 'Etiqueta', key: 'nEtiqueta', sortable: true, width: 'w-1/10' },

  ];

  return (
    <div>
      <div className="flex items-center justify-center mb-3">
        <button
          onClick={onGoToVincular}
          className="px-4 py-2 text-sm font-medium bg-vox-blue-600 hover:bg-vox-blue-700 text-white rounded-lg transition-colors duration-200"
        >
          Vincular novos patrimônios
        </button>
      </div>


      <DataTable
        data={patrimonios}
        headers={headers}
        noSort={false}
        exportButton={true}
        docTitle={`Patrimônios da Secretaria - ${secretaria?.nome} - ${cliente?.nome}`}
      />
    </div>
  )
}

export default TabelaPatrimoniosSecretaria;


